
    import Vue from "vue";
    import {Component} from "vue-property-decorator";
    import { VueInject } from "@/VueIntegration/VueInjectable";
    import {Synchroniser, TimeListener} from "@/Synchroniser";
    import { Slideshow } from "@/slideshow";
    import PreviousIcon from "../Icons/PreviousIcon.vue";
    import NextIcon from "../Icons/NextIcon.vue";
    import PauseIcon from "../Icons/PauseIcon.vue";
    import PlayIcon from "../Icons/PlayIcon.vue";
    import {IAppearance} from "@/Core/TutorialVariables";

    @Component({
        components: {PlayIcon, PauseIcon, NextIcon, PreviousIcon}
    })
    export default class Navigation extends Vue implements TimeListener {
        @VueInject("Synchroniser") sync: Synchroniser;
        @VueInject("Slideshow") slideshow: Slideshow;

        mounted() {
            this.sync.registerTimeListener(this);
            this.isPlaying = this.sync.isPlaying;
        }

        goNext() {
            this.slideshow.nextSlide();
        }

        goPrevious() {
            this.slideshow.previousSlide();
        }

        pause() {
            this.sync.pause();
        }

        play() {
            this.sync.play();
        }

        get buttonColours() {
            return this.slideshow.appearance.primaryColour;
        }

        isPlaying = false;

        playing() {
            this.isPlaying = true;
            return Promise.resolve();
        }

        stopping() {
            this.isPlaying = false;
        }

        pausing() {
            this.isPlaying = false;
        }

        seek(time: number) {

        }
    }
